import styled from 'styled-components';
import { HEADING_DEFAULT, HEADING_EXTRA_LARGE, HEADING_LARGE, HEADING_SMALL } from "../constants/typography";

export const HeadingXL = styled.h1`${HEADING_EXTRA_LARGE}`;
export const HeadingL = styled.h2`${HEADING_LARGE}`;
export const HeadingD = styled.h3`${HEADING_DEFAULT}`;
export const HeadingS = styled.h4`${HEADING_SMALL}`;
